import React from "react";

import Head from "next/head";
import { theme } from "~styles/theme/main/theme";

import Layout from "@/components/layouts/layout/Layout";
import { AboutContentSection } from "@/components/sections/about/AboutContentSection";

export const AboutPage = (): JSX.Element => {
  return (
    <Layout>
      <Head>
        <meta name="theme-color" content={theme.palette.primary.main} />
      </Head>
      <AboutContentSection />
    </Layout>
  );
};
